import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { IndividualFormNominate, CompanyFormNominate } from '@components';
import { NominationInfoDisplayObject } from '@services/FormFieldConfig';
import { iNominationFormValues } from '@services/NominationService';

function NominationStep11(): ReactElement {
  const { values }: { values: iNominationFormValues } = useFormikContext();
  const isIndividual = values.isDebtorTypeIndividual;// || false;
  // eslint-disable-next-line no-unused-expressions, no-nested-ternary
  return (
    <div>
      <span className="vfH2">Your details</span>
      {!isIndividual
        && (
          <p>Now we need <b>your details</b>, as the company's representative</p>
        )}
      {isIndividual
        && (
          <p>Now we need <b>your details</b>, as the person named on the fine.</p>
        )}
      <p>All fields are required unless specified</p>
      {isIndividual && <IndividualFormNominate displayObject={NominationInfoDisplayObject} currentStepNo="step11" />}
      {!isIndividual && <CompanyFormNominate displayObject={NominationInfoDisplayObject} currentStepNo="step11" />}
    </div>
  );
}

export default NominationStep11;
